export default __webpack_public_path__ + "static/tb_radler_03-f7413cffd12f9ce9e8f89cf7a6a6770b.svg";